import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';
import httpService from '../../services/httpService';

const initialState = {
    isLoading: false,
    phaseList: [],
    patientList: [],
    allChatRoom: [],
    chatView: "inbox",
    selectedRoom: {},
    countUnreadMessege: [],
    messegeUnreadCount: 0,
    unreadyMessage: 0,
    errorMessage:'',
    error:false
};


// fetch the all chat  list 
export const fetchChatRoom = createAsyncThunk(
    'bmr/fetchChatRoom',
    async (params, { rejectWithValue }) => {
        try {
            const response = await api.get('/chat/rooms/list', { params: params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch the all mention List
export const fetchRoomMention = createAsyncThunk(
    'bmr/fetchRoomMention',
    async (params, { rejectWithValue }) => {
        try {
            const response = await api.get('/chat/room/mention/list', { params: params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create the char room  
export const createChatRoom = createAsyncThunk(
    'bmr/createChatRoom',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/chat/room/create', data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
         notify.error(error || error?.message || error?.response?.data?.message || error?.response?.data)
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// create the mark as read  
export const markAsReadChat = createAsyncThunk(
    'bmr/markAsReadChat',
    async ({ id, room_id } = {}, { rejectWithValue }) => {
        try {
            const response = id
                ? await api.patch(`/chat/mention/mark-all-as-read?mention_id=${id}&room_id=${room_id}`)
                : await api.patch(`/chat/mention/mark-all-as-read`);
            return response.data;
        } catch (error) {
            notify.error(error ?? error?.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


// fetch the all chat history list 
export const fetchChatHistory = createAsyncThunk(
    'bmr/fetchChatHistory',
    async (args, { rejectWithValue }) => {
        try {
            const { roomId, params } = args
            const response = await api.get(`/chat/message/${roomId}/history`, { params: params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// fetch the all chat history list 
export const fetchChatPhaseList = createAsyncThunk(
    'bmr/fetchChatPhaseList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`chat/room/phaseList`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// uploadFiles
export const uploadChatFiles = createAsyncThunk(
    'bmr/uploadChatFiles',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await httpService.post(`uploadFileInChat`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'multipart/form-data'
                }
            });
            notify.success(response.message);
            return response.data;
        } catch (error) {
            notify.error(error || error?.message || error?.response || error?.response?.data)
            return rejectWithValue(error?.response ? error?.response?.data : error?.message);
        }
    }
);

// fetch the all chat media list 
export const fetchChatMedia = createAsyncThunk(
    'bmr/fetchChatMedia',
    async (args, { rejectWithValue }) => {
        try {
            const { messege_id } = args
            const response = await api.get(`/chat/message/${messege_id}/media`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


const bmrChatSlice = createSlice({
    name: 'bmrChat',
    initialState,
    reducers: {
        changeChatView(state, action) {
            state.chatView = action.payload
        },
        changeSelectedRoom(state, action) {
            state.selectedRoom = action.payload
        },
        addPhaseList(state, action) {
            state.phaseList = action.payload
        },
        addPatientList(state, action) {
            state.patientList = action.payload
        },
        addMoreChatRoom(state, action) {
            state.allChatRoom = [action.payload, ...state.allChatRoom]
        },
        updateAllChatRoom(state, action) {
            state.allChatRoom = action.payload
        },
        updateCountUnreadMessege(state, action) {
            state.countUnreadMessege = action.payload
        },
        updateMessegeUnreadCount(state, action) {
            state.messegeUnreadCount = action.payload
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all fetchChatRoom list
        builder
            .addCase(fetchChatRoom.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchChatRoom.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allChatRoom = action.payload.data.items
                state.unreadyMessage = action.payload.data.unready_message
            })
            .addCase(fetchChatRoom.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(createChatRoom.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createChatRoom.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(createChatRoom.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchChatHistory.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchChatHistory.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchChatHistory.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(uploadChatFiles.pending, (state) => {
                state.mediaLoading = true;
            })
            .addCase(uploadChatFiles.fulfilled, (state) => {
                state.mediaLoading = false;
            })
            .addCase(uploadChatFiles.rejected, (state) => {
                state.mediaLoading = false;
            });
        builder
            .addCase(fetchChatMedia.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchChatMedia.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchChatMedia.rejected, (state) => {
                state.isLoading = false;
            });

        builder
            .addCase(fetchChatPhaseList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchChatPhaseList.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchChatPhaseList.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchRoomMention.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchRoomMention.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchRoomMention.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(markAsReadChat.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(markAsReadChat.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(markAsReadChat.rejected, (state) => {
                state.isLoading = false;
            });

    },
});

export const { addPhaseList, updateMessegeUnreadCount, updateCountUnreadMessege, updateAllChatRoom, addPatientList, addMoreChatRoom, changeChatView, changeSelectedRoom } = bmrChatSlice.actions
export const selectChatErrorMessege = (state) => state.bmrChat.errorMessage;
export const selectChatError = (state) => state.bmrChat.error;
export const selectChatLoading = (state) => state.bmrChat.isLoading;
export const selectAllChatRoom = (state) => state.bmrChat.allChatRoom;
export const selectMediaLoading = (state) => state.bmrChat.mediaLoading;
export const selectAllPhaseList = (state) => state.bmrChat.phaseList;
export const selectAllPatientList = (state) => state.bmrChat.patientList;
export const selectChatView = (state) => state.bmrChat.chatView;
export const selectSelectedRoom = (state) => state.bmrChat.selectedRoom;
export const selectCountUnreadMessege = (state) => state.bmrChat.countUnreadMessege;
export const selectMessegeUnreadCount = (state) => state.bmrChat.messegeUnreadCount;
export const selectUnreadyMessage = (state) => state.bmrChat.unreadyMessage;





export default bmrChatSlice.reducer;
